export default function(state = {}, action) {
  const typeMap = {
    FRANCHISE_APPLY_PAGE_LOADING() {
      return {
        isLoading: true,
        franchiseApplyPage: action.franchiseApplyPage
      };
    },
    FRANCHISE_APPLY_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.franchiseApplyPage
      };
    },
    FRANCHISE_APPLY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.franchiseApplyPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
